/* =========================================================================
   Courses kill-switch.

   The courses aren't finished, so nobody outside the team should be able to
   open them yet. While courses are CLOSED every course URL redirects to
   /subscriptions — the /courses hub, all five tables of contents, the free
   first-lesson previews and every gated lesson alike. /subscriptions already
   explains that enrollment hasn't opened (see config/enrollment.js), so the
   two switches tell one story. The "Courses" navbar link is hidden as well,
   so there is nothing to click in the first place.

   Admins and testers are exempt and keep full access, so the courses can still
   be built and QA'd on the live site. That is the same client-side privilege
   check RestrictedRoute uses (utils/roles.js).

   Courses are closed unless REACT_APP_COURSES_OPEN is explicitly "true".
   `.env.development` turns it on so local work is unaffected; `.env.production`
   carries an explicit empty override. Never put the flag in plain `.env` — CRA
   loads that for production builds too, so it would silently ship the courses
   open.

   CRA inlines REACT_APP_* at build time, so opening the courses means editing
   `.env.production` and running `npm run build` + redeploy. Setting it on the
   server does nothing (same deal as REACT_APP_ENROLLMENT_OPEN).
   ========================================================================= */

// Before setting it to true in production, pass docs/launch-checklist.md.
export const COURSES_OPEN =
  String(process.env.REACT_APP_COURSES_OPEN || "").trim().toLowerCase() === "true";

export default COURSES_OPEN;
